import DrillDetails from '../components/excecutive/DrillDetails';

const DetailedTab = () => {
    return (
        <div className={`border-t py-5 my-3`}>
            <DrillDetails />
        </div>
    );
};

export default DetailedTab;
